<template>
  <v-layout row wrap>
    <v-flex xs12 md8>
      <v-card>
        <v-card-title>
          <span class="title">Create new approval user for mobile login</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="formSubmit" ref="form">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="approver.employee_id" label="Employee ID"
                              :error-messages="errors.collect('employee id')" v-validate="'required'"
                              data-vv-name="employee id" required></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field v-model="approver.salutation" label="Salutation" :error-messages="errors.collect('salutation')" v-validate="'required'"
                    data-vv-name="salutation" required></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field v-model="approver.first_name" label="First name"
                              :error-messages="errors.collect('first name')" v-validate="'required'"
                              data-vv-name="first name" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="approver.last_name" label="Last name"
                              :error-messages="errors.collect('last name')" v-validate="'required'"
                              data-vv-name="last name" required></v-text-field>
              </v-flex>


              <v-flex xs12>
                <v-select v-bind:items="getAllRanks" v-model="approver.rank_id" label="Release code"
                          item-value="id" :error-messages="errors.collect('release code')"
                          v-validate="'required'" data-vv-name="release code" required>
                  <template slot="selection" slot-scope="data">
                    {{ data.item.rank_initial }} - {{ data.item.description }}
                  </template>
                  <template slot="item" slot-scope="data">
                    {{ data.item.rank_initial }} - {{ data.item.description }}
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="approver.email" label="E-mail"
                              :error-messages="errors.collect('email')" v-validate="'required|email'"
                              data-vv-name="email" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="approver.password"
                  label="Password" name="password"
                  :error-messages="errors.collect('password')"
                  v-validate="'required|min:6'"
                  data-vv-name="password" 
                  required
                  :append-icon="e2 ? 'visibility' : 'visibility_off'" 
                  :append-icon-cb="() => (e2 = !e2)" 
                  :type="e2 ? 'password' : 'text'"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="approver.retype_password"
                  label="Confirm password"
                  :error-messages="errors.collect('confirm password')"
                  v-validate="'required|confirmed:password|min:6'"
                  data-vv-name="confirm password" 
                  required
                  :append-icon="e3 ? 'visibility' : 'visibility_off'" 
                  :append-icon-cb="() => (e3 = !e3)" 
                  :type="e3 ? 'password' : 'text'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  name="company_code"
                  :items="getAllCompanies"
                  v-model="approver.company_code"
                  item-value="company_code"
                  item-text="description"
                  label="Company code"
                  multiple
                  chips
                  v-validate="'required'" 
                  :error-messages="errors.collect('company_code')" 
                  data-vv-name="company_code"
                  hint="Choose one or more company code"
                  persistent-hint
                  required
                ></v-select>
              </v-flex>
            </v-layout>
            <!--<v-layout row wrap>-->
            <!--<v-flex xs12 md6>-->
            <!--<v-text-field v-model="approver.sap_user_name" label="SAP user name"-->
            <!--:error-messages="errors.collect('sap user name')" v-validate="'required'"-->
            <!--data-vv-name="sap user name" required></v-text-field>-->
            <!--</v-flex>-->
            <!--<v-flex xs12 md6>-->
            <!--<v-text-field v-model="approver.sap_release_code" label="SAP release code"-->
            <!--:error-messages="errors.collect('release code')" v-validate="'required'"-->
            <!--data-vv-name="release code" required></v-text-field>-->
            <!--</v-flex>-->
            <!--</v-layout>-->
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="onFormApprovalUserSubmit" dark color="accent" :loading="getLoading" :disable="getLoading">save
          </v-btn>
          <v-btn @click="clear" color="accent">clear</v-btn>
          <v-btn to="/approver">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'new-approver',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      approver: {
        company_code: [],
        employee_id: '',
        rank_id: '',
        email: '',
        password: '',
        retype_password: '',
        first_name: '',
        last_name: '',
        phone_no: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      e2: true,
      e3: true
    }
  },
  computed: {
    ...mapGetters(['getLoading', 'getResponse', 'getAllRanks', 'getAllCompanies'])
  },
  methods: {
    ...mapActions(['fetchAllRanks', 'addApprovalUser', 'fetchAllCompanies']),

    clear () {
      this.$refs.form.reset()
      this.$validator.reset()
    },

    onFormApprovalUserSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.addApprovalUser(this.approver).then(() => {
            let response = this.getResponse
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Added successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
            if (response.status === 200) {
              this.clear()
            }
          })
        }
      })
    }
  },
  mounted: function () {
    this.fetchAllRanks()
    this.fetchAllCompanies()
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile-user/NewApprover.vue